module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9666.b07626c8.jpg";